// StoresDataFetcher.js
import React, { useEffect, useState } from "react";
import { useAccount } from './account-context';
import { getApiPaths } from "./constants/healthEndpoints";

import useApi from "./useApi";

export default function StoresDataFetcher({ onDataLoaded }) {

  const { accountId } = useAccount();
    const API_URL_PATHS = getApiPaths(accountId);
  const { STORES_VIEW } = API_URL_PATHS;
  const {
    data: storesData,
    loading: storesLoading,
    error: storesError,
  } = useApi(STORES_VIEW);

useEffect(() => {
    if (storesData) {
      //console.log("Stores data loaded:", storesData); //  Console log here
      if (onDataLoaded) {
        
        onDataLoaded(storesData);
      }
    }
  }, [storesData, onDataLoaded]);

  if (storesLoading) return <div>Loading stores...</div>;
  if (storesError) return <div>Error loading stores: {storesError.message}</div>;

  return null; // This component only fetches and passes data up
}